import axios from 'axios';

const list = (data) => axios.get('/safe/working/list', data);
const save = (data) => axios.post('/safe/working/save', data);


export default {
  list,
  save,

}


